import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import { getLocalStorageItem, setLocalStorageItem } from './localStorage.js';
import { useSearchContext } from '../searchContext/SearchContextProvider.js';
import { SEARCH_BAR_FLYOUT_APPLICATION_NAME } from '../util/constants.js';

var useRecentSearch = function useRecentSearch() {
  var RECENT_SEARCHES_KEY = 'recentSearches';
  var MAX_RECENT_SEARCHES = 5;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    recentSearches = _useState2[0],
    setRecentSearches = _useState2[1];
  var _useSearchContext = useSearchContext(),
    logger = _useSearchContext.logger,
    applicationName = _useSearchContext.applicationName;
  useEffect(function () {
    var storedSearches = getLocalStorageItem(RECENT_SEARCHES_KEY, logger);
    if (storedSearches) {
      setRecentSearches(storedSearches);
    }
  }, []);
  var addRecentSearch = function addRecentSearch(searchTerm) {
    if (applicationName !== SEARCH_BAR_FLYOUT_APPLICATION_NAME) {
      return;
    }
    var normalizedSearchTerm = searchTerm.trim().toLowerCase().replace(/\s+/g, ' ');
    setRecentSearches(function (prevSearches) {
      var filteredSearches = prevSearches.filter(function (search) {
        return search !== normalizedSearchTerm;
      });
      var updatedSearches = [normalizedSearchTerm].concat(_toConsumableArray(filteredSearches)).slice(0, MAX_RECENT_SEARCHES);
      setLocalStorageItem(RECENT_SEARCHES_KEY, updatedSearches, logger);
      return updatedSearches;
    });
  };
  return {
    recentSearches: recentSearches,
    addRecentSearch: addRecentSearch
  };
};

export { useRecentSearch };
//# sourceMappingURL=useRecentSearch.js.map
